import { clientApi } from './CLIENT';

const url = '/api/dashboard/get-carbon-form-files?project_id=';
// eslint-disable-next-line no-return-await
export default async (id = '') => await clientApi().get(url + id).then((data) => data.data).catch((error) => {
  console.log(error?.response?.data);
});
